import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@ubisend/pulse-icons';

import BlockContainer from '../../BlockContainer';
import TextPreview from '../../TextPreview';

const MetricBlock = ({ icon, colour, ...props }) => {
  return (
    <BlockContainer colour={colour} {...props} aria-label="Metric block">
      <Icon outline type={icon} /> <TextPreview>{props.base.name}</TextPreview>
    </BlockContainer>
  );
};

MetricBlock.propTypes = {
  icon: PropTypes.string.isRequired,
  colour: PropTypes.string.isRequired,
  base: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired
    })
  ).isRequired
};

export default MetricBlock;
